import { updateDiscordChannelApi } from 'src/utils/api'
import { getBetTransactionData } from 'src/utils/getBetTransactionData'
import type { TicketMarket } from '@/Overtime/types/markets'
import type { OvertimeBetData } from 'src/utils/overtimeDiscordHelper'
import { formatCamelCaseToSpaces, formatTextToSlug } from '@/utils/helper'
import type { Chain } from 'viem'

const updateOvertimeDiscordChannel = async (
  ticketMarkets: TicketMarket[],
  betAmount: string,
  totalOdds: number,
  chain: Chain | undefined,
  ticketId: string,
  betToken: string,
  selectedCollateralSymbol: string,
  isCombo?: boolean,
  isLive?: boolean
) => {
  try {
    const updatedItems: OvertimeBetData[] = ticketMarkets.map(
      (market: TicketMarket) => {
        // Transform sport enum to object structure
        const sportName = formatCamelCaseToSpaces(market.sport.toString())
        const sportSlug = formatTextToSlug(market.sport.toString())

        return {
          gameId: market.gameId,
          leagueId: Number(market.leagueId), // Convert League enum to number
          typeId: Number(market.typeId), // Convert MarketType enum to number
          position: market.position,
          homeTeam: market.homeTeam,
          awayTeam: market.awayTeam,
          chain: chain,
          ticketId: ticketId,
          market: {
            homeTeam: market.homeTeam,
            awayTeam: market.awayTeam,
            leagueId: Number(market.leagueId),
            leagueName: market.leagueName,
            id: market.gameId,
            gameId: market.gameId,
            slug: formatTextToSlug(`${market.homeTeam}-${market.awayTeam}`),
            title: `${market.homeTeam} - ${market.awayTeam}`,
            participants: [
              { name: market.homeTeam },
              { name: market.awayTeam },
            ],
            startsAt: market.maturity,
            sport: {
              sportId: market.sport.toString(),
              name: sportName,
              slug: sportSlug,
            },
            league: {
              id: Number(market.leagueId),
              name: market.leagueName,
              slug: formatTextToSlug(market.leagueName),
              tournamentName: market.tournamentName,
            },
            country: {
              name: 'International Tournaments',
              slug: 'international-tournaments',
            },
            line: market.line,
            type: market.type,
            typeId: Number(market.typeId),
            odds: market.odds,
            positionNames: market.positionNames,
          },
          betAmount: betAmount,
          totalOdds: totalOdds,
          betToken: betToken,
          selectedCollateralSymbol: selectedCollateralSymbol,
          isCombo: isCombo,
          live: isLive,
        }
      }
    )

    const response = await updateDiscordChannelApi({
      items: updatedItems as any, // Type assertion needed as API expects AzuroSDK.BetslipItem[]
      type: 'overtime',
    })

    return response
  } catch (error) {
    const err = error as Error
    console.error('Error updating Discord channel for Overtime', err)
    throw err
  }
}

export default updateOvertimeDiscordChannel
